import { Result, validatedApiCall } from '../api';
import { UUID } from '../../types/standard';
import { Project } from '../../types/projects/projects';
import { APIValidationError } from '../../types/api/api';

export const getProjectById = async (
  id: UUID
): Promise<Result<Project, APIValidationError>> => {
  return validatedApiCall<Project>(`/api/proyectos/${id}`, {
    method: 'GET',
    auth: true,
  });
};
